const isBrowser = () => typeof window !== 'undefined';

const getBaseUrlIfBrowser = () =>
  isBrowser() ? `${window.location.protocol}//${window.location.host}` : '';

export default getBaseUrlIfBrowser;
